const HeadersVisits = [
  { text: "ID Pedido", value: "request_id", sortable: true, show: true },
  { text: "Tipo", value: "visit_type.id", sortable: false, show: true },
  {
    text: "Estado",
    value: "visit_status",
    groupable: false,
    sortable: false,
    show: true
  },
  { text: "Cliente", value: "client", show: true },
  { text: "Servicio", value: "service_name", show: true },
  { text: "Fecha", value: "visit_date", show: true },
  {
    text: "Desde",
    value: "arrival_time",
    sortable: false,
    groupable: false,
    show: true
  },
  {
    text: "Hasta",
    value: "departure_time",
    sortable: false,
    groupable: false,
    show: true
  }
];

export default HeadersVisits;
